const parseDate = (date: Date | string) => {
    // This function is used to transform the date to the correct format which is independent of GMT.
    // which avoids the date being displayed as the previous day.
    if (!date) {
        return null;
    }
    try {
        if (typeof date === 'string' && date.length > 0) {
            return new Date(date.slice(0, 10));
        } else if (date && date instanceof Date) {

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            const formattedDate = `${year}-${month}-${day}`;
            return new Date(formattedDate);
        }
    } catch (e) {
        return null;
    }
    return null;
}

export default parseDate;